import { useDispatch } from 'react-redux'
import Icon24, { Icon20 } from 'builder/components/Icon'
import { CustomAlertType, JobSearchNotificationType } from 'builder/modules/jobSearch/types'
import { useI18n } from 'builder/hooks/useI18n'
import Toggle from 'builder/components/Toggle'
import { SettingNew } from 'builder/components/Icon/24x24'
import { actions as jobSearchActions } from 'builder/modules/jobSearch'

import { useTranslatedFrequenciesString } from '../../hooks/useTranslatedFrequenciesString'
import { useMutationCustomAlert } from '../../hooks/useMutationCustomAlert'
import {
  ContainerText,
  SubHead,
  Body,
  TimeIcon,
  Wrapper,
  WrapperToggle,
  Button,
  ContainerAlert,
  Container,
} from './styles'

interface Props extends CustomAlertType {
  onClick: () => void
}
const TRANSLATION = 'builder.job_search.alert_modal.custom_alert'

export const CustomAlert = ({
  active,
  id,
  targetRole,
  onlyRemoteJobs,
  location,
  frequency,
  onClick,
}: Props) => {
  const { getTranslatedTextFrequency } = useTranslatedFrequenciesString()
  const { i18n } = useI18n()

  const mutationCustomAlert = useMutationCustomAlert()
  const dispatch = useDispatch()

  const handleToggleChange = async () => {
    try {
      await mutationCustomAlert.mutateAsync({
        data: { id, active: !active },
        shouldUpdateCache: true,
      })
    } catch (e) {
      dispatch(jobSearchActions.setNotification(JobSearchNotificationType.snackbar_fail))
    }
  }

  return (
    <Container data-custom-alert-id={id} $active={Boolean(active)}>
      <ContainerAlert>
        <Wrapper>
          <SubHead>{targetRole}</SubHead>
          <ContainerText>
            <Body>
              <Icon24.NewLocation />
              {location}
              {onlyRemoteJobs && location && ', '}
              {onlyRemoteJobs && i18n.t(`builder.job_search.remote`)}
            </Body>
            <Body>
              <TimeIcon>
                <Icon20.Clock />
              </TimeIcon>
              {frequency && getTranslatedTextFrequency(frequency)}
            </Body>
          </ContainerText>
        </Wrapper>
        <WrapperToggle>
          <Toggle
            disabled={mutationCustomAlert.isLoading}
            checked={active}
            onClick={handleToggleChange}
          />
        </WrapperToggle>
      </ContainerAlert>
      <Button onClick={onClick}>
        <SettingNew />
        {i18n.t(`${TRANSLATION}.customize`)}
      </Button>
    </Container>
  )
}
